import {Component, AfterViewChecked, Input, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements AfterViewChecked {
  // input
  @Input() meta: any;
  // output
  @Output() pageChanged = new EventEmitter();
  @Output() limitChanged = new EventEmitter();
  pages: Array<number> = new Array<number>();
  locale = 'fr';

  constructor(private changeDetectionRef: ChangeDetectorRef) {
  }

  /**
   * Init pages
   *
   * @return void
   */
  ngAfterViewChecked(): void {
    this.pages = new Array<number>();

    // Get page info
    const firstPage: number = this.meta.firstPage;
    const lastPage: number = this.meta.lastPage;
    const currentPage: number = this.meta.current_page;
    const firstPrevious: number = currentPage - 2;
    const secondPrevious: number = currentPage - 1;
    const firstNext: number = currentPage + 1;
    const secondNext: number = currentPage + 2;

    // Init pages button
    if (firstPrevious >= firstPage) {
      this.pages.push(firstPrevious);
    }
    if (secondPrevious >= firstPage) {
      this.pages.push(secondPrevious);
    }
    this.pages.push(currentPage);
    if (firstNext <= lastPage) {
      this.pages.push(firstNext);
    }
    if (secondNext <= lastPage) {
      this.pages.push(secondNext);
    }

    this.changeDetectionRef.detectChanges();
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   * @return void
   */
  onLimitChanged(perPage: number): void {
    this.limitChanged.emit(perPage);
  }

  /**
   * When page changed
   *
   * @param page The page
   * @return void
   */
  onPageChanged(page: number): void {
    this.pageChanged.emit(page);
  }
}
